import gql from 'graphql-tag';

export const calendarEventQuery = gql`
  query getEvent($slug: ID!) {
    event(id: $slug, idType: SLUG) {
      content
      description
      eventId
      eventTypes {
        nodes {
          name
          slug
        }
      }
      eventSerieses {
        nodes {
          name
          slug
        }
      }
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageWidth
      imageSrcset
      multisession
      multisessionCta {
        label
        link
      }
      title
      venues {
        nodes {
          name
        }
      }
    }
  }
`;

export const calendarOccurrencesQuery = gql`
  query getOccurrences($eventId: String) {
    eventOccurrences(first: 1000, where: { withDrafts: true, eventId: $eventId }) {
      nodes {
        calendarLinks {
          key
          value
        }
        end {
          day
          meridiem
          month
          time
          timezone
          year
          weekday
        }
        excerpt
        eventSlug
        eventTypes {
          nodes {
            name
            slug
          }
        }
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        hideEventTimes
        hideStartTime
        multisession
        soldOutLabel
        specificImage {
          altText
          description
          imageSrcset
          sourceUrl
        }
        specificText
        start {
          day
          isoDate
          meridiem
          month
          status
          time
          timezone
          year
          weekday
        }
        title
        ticketLabel
        ticketLink
        timezoneAbbr
        venue
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
